import { ReactElement } from 'react';
import cc from 'classcat';
import { MATCH_TRACKER_AVAILABLE_SPORTS } from 'utils/constants/sportsbook/match-tracker-sports';
import { isMobile } from 'utils/is-mobile';
import {
  ESportsbookLayoutTypes,
  ESportsbookPageTypes
} from 'interfaces/sportsbook-configs';
import { AdvancedHeaderBreadcrumb } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedHeaderBreadcrumb';
import { ADDITIONAL_STATISTICS_LAYOUTS } from 'components/GameDetails/AdditionalStatistics';
import { MarketsListOnlySkeleton } from 'components/MarketsList/MarketsListOnlySkeleton';
import { MatchHeaderSkeleton } from 'components/MatchHeader/Prematch/MatchHeaderSkelton';
import { MatchInfoCardSkeleton } from 'components/MatchInfoCard/skeleton';
import { GameHeaderSkeleton } from 'newcomponents/Shared/sportsbook/GameHeader/GameHeaderSkeleton';
import { StreamCourtSkeleton } from 'newcomponents/Shared/sportsbook/MatchStreaming/Skeleton/Details/StreamCourtSkeleton';
import { HorizontalMenu } from 'newcomponents/UI/HorizontalMenu';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import './index.less';

export const SingleGameViewSkeleton = ({
  isLive,
  onBack,
  showGoBack,
  showAdvancedHeader,
  hasAdditionalStatistics
}: {
  isLive: boolean;
  onBack?: () => void;
  showGoBack?: boolean;
  hasAdditionalStatistics?: boolean;
  showAdvancedHeader?: boolean;
}): ReactElement => {
  const { params } = useSbRouteMatch();
  const configs = useSportsbookConfigs();

  const AdditionalLayoutSkeleton =
    ADDITIONAL_STATISTICS_LAYOUTS[params.sport]?.skeleton;

  const isLivePage = configs.pageType === ESportsbookPageTypes.live;
  const isEuropeanLayout =
    configs.spbLayoutType === ESportsbookLayoutTypes.EUROPEAN;

  return (
    <div
      className={cc([
        'singleGameViewPageSkeleton',
        {
          'singleGameViewPageSkeleton--mobile': isMobile(),
          'singleGameViewPageSkeleton--mobile--live': isMobile() && isLive
        }
      ])}
    >
      {showAdvancedHeader && <AdvancedHeaderBreadcrumb />}
      {((isMobile() && onBack) || showGoBack) && <GameHeaderSkeleton />}

      {isMobile() || isLive || isLivePage ? (
        <div
          className={cc([
            'matchInfo__wrapper-mobile',
            { 'matchInfo__wrapper--european': isEuropeanLayout && !isMobile() }
          ])}
        >
          <MatchInfoCardSkeleton sportAlias={params.sport} />
        </div>
      ) : (
        <MatchHeaderSkeleton />
      )}

      {isLivePage ? (
        !isMobile() ? (
          hasAdditionalStatistics ? (
            <AdditionalLayoutSkeleton className="additionalStatisticsSkeleton" />
          ) : null
        ) : MATCH_TRACKER_AVAILABLE_SPORTS.includes(params.sport) || isLive ? (
          <StreamCourtSkeleton classNames="streamCourtSkeleton__layer" />
        ) : null
      ) : null}

      {isMobile() &&
        (isLive || isLivePage) &&
        configs.spbLayoutType !== ESportsbookLayoutTypes.ADVANCED && (
          <HorizontalMenu
            size="large"
            selectedKey="markets"
            onChange={() => {}}
            items={[
              {
                key: 'markets',
                title: (
                  <Skeleton
                    title={{
                      style: { width: '140px', margin: '0px', height: '12px' }
                    }}
                    paragraph={false}
                    active
                  />
                )
              },
              {
                key: 'matches',
                title: (
                  <Skeleton
                    title={{
                      style: { width: '140px', margin: '0px', height: '12px' }
                    }}
                    paragraph={false}
                    active
                  />
                )
              }
            ]}
          />
        )}
      <MarketsListOnlySkeleton />
    </div>
  );
};
